import { useTranslation } from "react-i18next";
import { Button } from "@nexus/ui";

export interface KpiVisibilityToggleProps {
  revealHidden: boolean;
  hiddenCount: number;
  onToggle: (revealHidden: boolean) => void;
}

/**
 * Reveals the hidden KPI boxes so they can be unhidden. Replaces the disabled
 * "Metrics" placeholder button in the Overview drawer.
 */
export function KpiVisibilityToggle({
  revealHidden,
  hiddenCount,
  onToggle,
}: KpiVisibilityToggleProps) {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="h-7 gap-1.5 text-xs"
      aria-pressed={revealHidden}
      iconStart={revealHidden ? "eye-off" : "eye"}
      onClick={() => onToggle(!revealHidden)}
    >
      {revealHidden
        ? t("kpiSettings.hideHidden", "Hide hidden KPIs")
        : t("kpiSettings.revealHidden", "Show hidden KPIs")}
      {hiddenCount > 0 && !revealHidden ? ` (${hiddenCount})` : ""}
    </Button>
  );
}
